exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.user--info[data-v-b80eec2a] {\n  position: relative;\n}\n.user--info__avatar span[data-v-b80eec2a] {\n    font-size: 15px !important;\n}\n.user--info__main div[data-v-b80eec2a] {\n    font-size: 15px;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/building-monitor/components/bm-user-profile-widget/styles.scss"],"names":[],"mappings":";AAAA;EACE,mBAAkB;CAanB;AAXE;IAEG,2BAA0B;CAC3B;AAGF;IAEG,gBAAe;CAChB","file":"styles.scss","sourcesContent":[".user--info {\n  position: relative;\n\n  &__avatar {\n    span {\n      font-size: 15px !important;\n    }\n  }\n\n  &__main {\n    div {\n      font-size: 15px;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b80eec2a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/building-monitor/components/bm-user-profile-widget/styles.scss
// module id = PpZN
// module chunks = 0